import { ANCHOR_ORIGIN, AUTO_HIDE_DURATION, MAX_SNACK } from '@constants/notificationStack';
import { SnackbarProvider as NotistackProvider } from 'notistack';
import type { ReactNode } from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSnackbar } from 'notistack';

interface SnackbarProviderProps {
  children: ReactNode;
}

// Create a component for the close button
const CloseButton = ({ id }: { id: string | number }) => {
  const { closeSnackbar } = useSnackbar();

  return (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={() => closeSnackbar(id)}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );
};

export const SnackbarProvider = ({ children }: SnackbarProviderProps) => {
  return (
    <NotistackProvider
      maxSnack={MAX_SNACK}
      anchorOrigin={ANCHOR_ORIGIN}
      autoHideDuration={AUTO_HIDE_DURATION}
      action={(snackbarId) => <CloseButton id={snackbarId} />}
    >
      {children}
    </NotistackProvider>
  );
}; 